import { atlassianApiGateway } from '@trello/config';
import { sendNetworkErrorEvent } from '@trello/error-reporting';
import { trelloFetch } from '@trello/fetch';
import { parseNetworkError } from '@trello/graphql-error-handling';
import type { ResolverContext } from './types';

interface AtlassianOrganizationDomainClaim {
  domain: string;
  isVerified: boolean;
  verificationType: string | null;
  status: string;
  timestamp: string;
}

export async function atlassianOrganizationDomains(
  orgId: string,
  context: ResolverContext,
) {
  // https://domain-claim-service.prod.atl-paas.net/api.html#operation/getDomainClaims
  const apiUrl = `${atlassianApiGateway}gateway/api/adminhub/organization/${orgId}/domainClaims`;

  const response = await trelloFetch(apiUrl, undefined, {
    clientVersion: context.clientAwareness.version,
    networkRequestEventAttributes: {
      source: 'graphql',
      resolver: 'Member.atlassianOrganizations',
      operationName: context.operationName,
    },
  });

  /*
    TODO: It would be highly unexpected for DCS to fail to return any claimed
    domains for a verified vortex org. But in that case, log it and return
    an empty array, or throw an error
  */
  if (response.ok) {
    const model = await response.json();

    const domainClaims = model.domainClaims as AtlassianOrganizationDomainClaim[];
    return domainClaims.map((domainClaim) => domainClaim.domain);
  } else {
    sendNetworkErrorEvent({
      url: apiUrl,
      response: await response.clone().text(),
      status: response.status,
      operationName: context.operationName,
      ownershipArea: 'trello-enterprise',
    });
    throw await parseNetworkError(response);
  }
}
